import create from './createAction'

export const CREATE_PAYMENT_INTENT = 'CREATE_PAYMENT_INTENT'
export const SET_PAYMENT_INTENT = 'SET_PAYMENT_INTENT'
export const GET_PAYMENT_STATUS = 'GET_PAYMENT_STATUS'
export const SET_PAYMENT_STATUS = 'SET_PAYMENT_STATUS'

export const createPaymentIntent = create(CREATE_PAYMENT_INTENT)
export const setPaymentIntent = create(SET_PAYMENT_INTENT)
export const getPaymentStatus = create(GET_PAYMENT_STATUS)
export const setPaymentStatus = create(SET_PAYMENT_STATUS)
